import { useEffect, useState } from "react";
import { Button } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useSWRConfig } from "swr";
import { fetcher } from "../../../../services/fetcher";
import {
  errorNotifications,
  successNotifications,
} from "../../../../utils/handleNotifications";
import { getTripPickEndpoint, TRIP_STATS_ENDPOINT } from "../../utils/allPolicyConstants";

// Persists picked trip IDs across component remounts within the same session
const sessionPickedIds = new Set();

const isSuccessStatus = (status) => String(status || "").toUpperCase() === "SUCCESS";

const revalidateStats = (mutate) =>
  mutate(
    (key) => typeof key === "string" && key === TRIP_STATS_ENDPOINT,
    undefined,
    { revalidate: true }
  );

const TripPickDoneButton = ({ tripId, isPicked, status }) => {
  const { mutate } = useSWRConfig();
  const isAlreadyPicked = Boolean(isPicked) || sessionPickedIds.has(tripId);
  const [picked, setPicked] = useState(isAlreadyPicked);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isPicked || sessionPickedIds.has(tripId)) {
      setPicked(true);
    }
  }, [isPicked, tripId]);

  if (picked) {
    return (
      <Button
        size="compact-xs"
        variant="filled"
        color="#D1FFD9"
        w="auto"
        px={10}
        leftSection={<IconCheck size={12} stroke={2.5} />}
        style={{ alignSelf: "flex-start", color: "#24CB3F" }}
        styles={{ section: { color: "#24CB3F" } }}
      >
        Picked
      </Button>
    );
  }

  if (!tripId || !isSuccessStatus(status)) {
    return null;
  }

  const handleClick = async (event) => {
    event.stopPropagation();
    if (isSubmitting || picked) return;

    setIsSubmitting(true);
    try {
      await fetcher(getTripPickEndpoint(tripId), "POST", { picked: true });
      sessionPickedIds.add(tripId);
      setPicked(true);
      successNotifications("Trip marked as picked");
      await revalidateStats(mutate);
    } catch (error) {
      errorNotifications(error?.response?.data || "An error occurred", error);
      setIsSubmitting(false);
    }
  };

  return (
    <Button
      size="compact-xs"
      color="#033F7C"
      w="auto"
      px={10}
      leftSection={<IconCheck size={12} stroke={2.5} />}
      loading={isSubmitting}
      disabled={isSubmitting || picked}
      onClick={handleClick}
      style={{ alignSelf: "flex-start" }}
    >
      Unpicked
    </Button>
  );
};

export default TripPickDoneButton;
